import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';

import { ButtonsAssignment } from './dialog-buttons.component';

@Component({
  template: '',
  styleUrls: [ './dialog.scss' ]
})
export class DialogComponent
{
  public buttons: ButtonsAssignment;

  constructor(@Inject(MAT_DIALOG_DATA) protected dialogData: any)
  {
    this.buttons = this.dialogData.buttons ? this.dialogData.buttons : {};
  }
}



// WEBPACK FOOTER //
// ./src/app/dialogs/dialog.component.ts